var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventTypeAlert01 = function SvgEventTypeAlert01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 58.82,
    y1: 209.05,
    x2: 163.85,
    y2: 83.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 46.76,
    y1: 198.99,
    x2: 151.79,
    y2: 73.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 29.47,
    y1: 184.57,
    x2: 134.5,
    y2: 58.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -22.48,
    y1: 141.24,
    x2: 82.55,
    y2: 15.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 81.41,
    y1: 227.89,
    x2: 186.45,
    y2: 101.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -13.86,
    y1: 148.43,
    x2: 91.17,
    y2: 22.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -37.75,
    y1: 128.5,
    x2: 67.28,
    y2: 2.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 35.55,
    y1: 189.64,
    x2: 140.58,
    y2: 63.71,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M182.03,188.28h-17.58v-17.58c0-3.24-2.62-5.86-5.86-5.86h-5.86v-64.84c0-29.08-23.66-52.73-52.73-52.73s-52.73,23.66-52.73,52.73v64.84h-5.86c-3.24,0-5.86,2.62-5.86,5.86v17.58h-17.58c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86h164.06c3.24,0,5.86-2.62,5.86-5.86s-2.62-5.86-5.86-5.86ZM58.98,100c0-22.62,18.4-41.02,41.02-41.02s41.02,18.4,41.02,41.02v64.84H58.98v-64.84ZM152.73,188.28H47.27v-11.72h105.47v11.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,129.3c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86,5.86-2.62,5.86-5.86-2.62-5.86-5.86-5.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100,82.42c-3.24,0-5.86,2.62-5.86,5.86v23.44c0,3.24,2.62,5.86,5.86,5.86s5.86-2.62,5.86-5.86v-23.44c0-3.24-2.62-5.86-5.86-5.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.83,100c0-3.24-2.62-5.86-5.86-5.86H5.86C2.62,94.14,0,96.76,0,100s2.62,5.86,5.86,5.86h12.11c3.24,0,5.86-2.62,5.86-5.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.14,94.14h-12.11c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86h12.11c3.24,0,5.86-2.62,5.86-5.86s-2.62-5.86-5.86-5.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100,23.83c3.24,0,5.86-2.62,5.86-5.86V5.86c0-3.24-2.62-5.86-5.86-5.86s-5.86,2.62-5.86,5.86v12.11c0,3.24,2.62,5.86,5.86,5.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37.85,46.14c1.14,1.14,2.64,1.72,4.14,1.72s3-.57,4.14-1.72c2.29-2.29,2.29-6,0-8.29l-8.29-8.29c-2.29-2.29-6-2.29-8.29,0-2.29,2.29-2.29,6,0,8.29l8.29,8.29Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158,47.85c1.5,0,3-.57,4.14-1.72l8.29-8.29c2.29-2.29,2.29-6,0-8.29-2.29-2.29-6-2.29-8.29,0l-8.29,8.29c-2.29,2.29-2.29,6,0,8.29,1.14,1.14,2.64,1.72,4.14,1.72Z"
  })));
};
export default SvgEventTypeAlert01;